module.exports = __webpack_public_path__ + "static/media/FarmAccom.c8a9482c.png";